import * as React from 'react';
import { ActivityDefinitionListItem } from './ActivityDefinitionListItem';
import { List, Divider } from '@material-ui/core';
import { ActivityDefinition } from '../../../model/activities';

interface IProps {
    classes: any;
    selectedId: string;
    allActivities: ActivityDefinition[];
    onSelected: (id: string) => any;
    delete: (id: string) => void;
    confirm: (id: string) => void;
    navigateTo: (path: string) => void;

}
export const ActivityDefinitions = (props: IProps) => {
    return <List className={props.classes.root}>
        {props.allActivities && props.allActivities.map(c =>
            <>
                <ActivityDefinitionListItem
                    isSelected={props.selectedId === c._id}
                    activity={c}
                    onSelected={props.onSelected}
                    navigateTo={props.navigateTo}
                    classes={props.classes}
                    key={c._id}
                    delete={props.delete}
                    confirm={props.confirm}
                />
                <Divider />
            </>)}
    </List>
}